// @ts-check

import React, { useRef, useState } from "react"
import IndividualReportContent from "./controllers/IndividualReportContent.controller"
import IndividualReportHeader from "./controllers/IndividualReportHeader.controller"

const IndividualReport = () => {
  const [
    openCreateTaskForTeamMemberModal,
    setOpenCreateTaskForTeamMemberModal,
  ] = useState(false)
  const [currentTab, setCurrentTab] = useState(0)

  /** @type {React.RefObject<import("./controllers/table/IndividualReportTableContainer.controller.types").IndividualReportTableContainerRef | null>} */
  const registeredTasksRef = useRef(null)

  return (
    <>
      <IndividualReportHeader
        currentTab={currentTab}
        openCreateTaskForTeamMemberModal={openCreateTaskForTeamMemberModal}
        setOpenCreateTaskForTeamMemberModal={
          setOpenCreateTaskForTeamMemberModal
        }
        registeredTasksRef={registeredTasksRef}
      />
      <IndividualReportContent
        setCurrentTab={setCurrentTab}
        openCreateTaskForTeamMemberModal={openCreateTaskForTeamMemberModal}
        setOpenCreateTaskForTeamMemberModal={
          setOpenCreateTaskForTeamMemberModal
        }
        registeredTasksRef={registeredTasksRef}
      />
    </>
  )
}

export default IndividualReport
